"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.palette = void 0;
var colors_1 = require("../generated/colors");
exports.palette = {
    mode: "light",
    primary: {
        contrastText: colors_1.colors.White,
        main: colors_1.colors.Primary,
        // light: colors.primaryLight,
        // dark: colors.primaryDark,
    },
    secondary: {
        contrastText: colors_1.colors.White,
        main: colors_1.colors.Secondary,
    },
    error: {
        main: colors_1.colors.Error,
    },
    warning: {
        main: colors_1.colors.Warning,
    },
    info: {
        main: colors_1.colors.Info,
    },
    success: {
        main: colors_1.colors.Success,
    },
    text: {
        primary: colors_1.colors.Text,
    },
};
//# sourceMappingURL=palette.js.map